import { VALIDATION_TEMPLATE } from './validationTemplete';

export const RATE_VALIDATION = {
  FIELDS: [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december',
  ],
  MESSAGE: {
    january: {
      pattern: VALIDATION_TEMPLATE.rate(),
    },
    february: {
      pattern: VALIDATION_TEMPLATE.rate(),
    },
    march: {
      pattern: VALIDATION_TEMPLATE.rate(),
    },
    april: {
      pattern: VALIDATION_TEMPLATE.rate(),
    },
    may: {
      pattern: VALIDATION_TEMPLATE.rate(),
    },
    june: {
      pattern: VALIDATION_TEMPLATE.rate(),
    },
    july: {
      pattern: VALIDATION_TEMPLATE.rate(),
    },
    august: {
      pattern: VALIDATION_TEMPLATE.rate(),
    },
    september: {
      pattern: VALIDATION_TEMPLATE.rate(),
    },
    october: {
      pattern: VALIDATION_TEMPLATE.rate(),
    },
    november: {
      pattern: VALIDATION_TEMPLATE.rate(),
    },
    december: {
      pattern: VALIDATION_TEMPLATE.rate(),
    },
  },
  RULES: {
    january: {
      pattern: /^\d+(\.\d{1,2})?$/,
      required: false,
      nullable: true,
    },
    february: {
      pattern: /^\d+(\.\d{1,2})?$/,
      required: false,
      nullable: true,
    },
    march: {
      pattern: /^\d+(\.\d{1,2})?$/,
      required: false,
      nullable: true,
    },
    april: {
      pattern: /^\d+(\.\d{1,2})?$/,
      required: false,
      nullable: true,
    },
    may: {
      pattern: /^\d+(\.\d{1,2})?$/,
      required: false,
      nullable: true,
    },
    june: {
      pattern: /^\d+(\.\d{1,2})?$/,
      required: false,
      nullable: true,
    },
    july: {
      pattern: /^\d+(\.\d{1,2})?$/,
      required: false,
      nullable: true,
    },
    august: {
      pattern: /^\d+(\.\d{1,2})?$/,
      required: false,
      nullable: true,
    },
    september: {
      pattern: /^\d+(\.\d{1,2})?$/,
      required: false,
      nullable: true,
    },
    october: {
      pattern: /^\d+(\.\d{1,2})?$/,
      required: false,
      nullable: true,
    },
    november: {
      pattern: /^\d+(\.\d{1,2})?$/,
      required: false,
      nullable: true,
    },
    december: {
      pattern: /^\d+(\.\d{1,2})?$/,
      required: false,
      nullable: true,
    },
  },
};
